<template>
  <div class="grid-container mb-1">
   <div class="grid-row">
      <div
        class="titulo-grid"
        v-b-toggle.collapse-1
        variant="primary"
        clickable
      >
        Informações Cliente
        <!-- <SGPIconComponent
          icon="mdi-chevron-down-circle"
          class="when-closed float-right"
          color="#444444"
          
        />
       
        <SGPIconComponent
          icon="mdi-chevron-up-circle"
          class="when-open float-right"
          color="#444444"
        /> -->
      </div>
    </div>
      <div class="grid-row">
        <div class=" titulo">
          Cliente
        </div>
        <div class="">        
          {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_cliente.cliente.toUpperCase() }}
          <SGPIconComponent
            icon="mdi-card-account-phone-outline"
            color="red"
            @click="$emit('emitAbrirModalContato')"
            class="ml-2"
          /> 
        </div>
        <div class=" titulo">
          Orgão de vendas
        </div>
        <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_orgao_venda.orgao_venda">
          {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_orgao_venda.orgao_venda.toUpperCase() }}
        </span>
          <span v-else>-</span>
        </div>
      </div>
      <template v-if="podeVisualizarFichaCompleta">
        <div class="grid-row">
          <div class=" titulo">
            Classificação Cliente
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.classif_cliente">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.classif_cliente.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Centro de manutenção (CM)
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_cm.cm">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_cm.cm.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Contrato
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.contrato">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.contrato.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Cadastro Nacional de Localidades (CNL)
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_cnl">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_cnl.cnl.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Solicitaçao OTS/OE
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.solicitacao_ots_oe">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.solicitacao_ots_oe.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Ação
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_acao.acao">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_acao.acao.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Coordenação Implantação
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.cood_implant">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cood_implant.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Estado (UF)
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.estado">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.estado.estado.toUpperCase() }}
            ({{ dadosFichaTecnica.pco_tarefa.pco_circuito.estado.uf.toUpperCase() }})
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Execução CNL
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.exec_cnl">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.exec_cnl.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Regional
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.regional">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.regional.regional.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Projeto
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.projeto">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.projeto.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Número ITP
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.numero_itp">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.numero_itp.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Nome da dependência do Cliente
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.projeto_nome_dependencia_cliente">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.projeto_nome_dependencia_cliente.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            IDP
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.projeto_idp">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.projeto_idp.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Razão Social
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.razao_social">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.razao_social.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            Conta Corrente
          </div>
          <div class="">
          <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.conta_corrente">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.conta_corrente.toUpperCase() }}
          </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            CNPJ
          </div>
          <div class="">
            <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.cnpj">
              {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cnpj.toUpperCase() }}
            </span>
            <span v-else>-</span>
          </div>
          <div class=" titulo">
            OS SAPWEB
          </div>
          <div class="">
            <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.codigo_sap_web">
              {{ dadosFichaTecnica.pco_tarefa.pco_circuito.codigo_sap_web.toUpperCase() }}
            </span>
              <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Inscrição Estadual
          </div>
          <div class="">
            <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.inscricao_estadual">
              {{ dadosFichaTecnica.pco_tarefa.pco_circuito.inscricao_estadual }}
            </span>
            <span v-else>-</span>
          </div>
          <div class=""></div>
          <div class=""></div>
        </div>        
        <div class="grid-row">
          <div class=" titulo-grid">
            Responsáveis
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            CEC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cec.toUpperCase() }}
          </div>
          <div class=" titulo">
            PVTEC Execução
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.pvtec_exec.toUpperCase() }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Nome CEC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_cec 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_cec.name
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Nome PVTEC Execução
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_pvtec_exec 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_pvtec_exec.name
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Telefone CEC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_cec 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_cec.telefone_1
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Telefone PVTEC Execução
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_pvtec_exec 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_pvtec_exec.telefone_1
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            CS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cs.toUpperCase() }}
          </div>
          <div class=" titulo">
            GECS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.gecs.toUpperCase() }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Nome CS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_c_s 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_c_s.name
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Nome GECS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gecs 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gecs.name
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Telefone CS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_c_s 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_c_s.telefone_1
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Telefone GECS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gecs 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gecs.telefone_1
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            GC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.gc.toUpperCase() }}
          </div>
          <div class=" titulo">
            GEV
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.gev.toUpperCase() }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Nome GC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gc 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gc.name
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Nome GEV
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gev 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gev.name
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Telefone GC
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gc 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gc.telefone_1
              : '-' 
            }}
          </div>
          <div class=" titulo">
            Telefone GEV
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.user_gev 
              ? dadosFichaTecnica.pco_tarefa.pco_circuito.user_gev.telefone_1
              : '-' 
            }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Pendência CS
          </div>
          <div class="">
            {{ dadosFichaTecnica.pco_tarefa.pco_circuito.pendencia_cs.toUpperCase() }}
          </div>
          <div class=" titulo">
          </div>
          <div class="">
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo-grid">
            Datas
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Data Agendamento
          </div>
          <div class="">
            <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.data_agendamento">
              {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_agendamento) }}
            </span>
            <span v-else>-</span>
          </div>

          <div class=" titulo">
            Data Forecast
          </div>
          <div class="">
            <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.data_forecast">
              {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_forecast, true) }}
            </span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Data Aprazada
          </div>
          <div class="">
            {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_aprazada, true) }}
          </div>
          <div class=" titulo">
            Data Compromisso Cliente
          </div>
          <div class="">
            {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_prometida, true) }}
          </div>
        </div>
        <div class="grid-row">
          <div class=" titulo">
            Data Cadastro
          </div>
          <div class="">
            {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_cadastro, true) }}
          </div>
          <div class=" titulo">
            Data Previsão de Entrega do Acesso
          </div>
          <div class="">
            {{ formataDataBr(dadosFichaTecnica.pco_tarefa.pco_circuito.data_previsao_entrega, true) }}
          </div>
        </div>      
      </template>

      <ContatosPcoCircuitoComponent :contatos="dadosFichaTecnica.pco_tarefa.pco_circuito.contatos" />
  </div>
</template>

<script>

import { formataDataBr } from '@/common/boot/Utils'
import ContatosPcoCircuitoComponent from './ContatosPcoCircuitoComponent'

export default {
  name: "InformacoesClienteComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    },

    podeVisualizarFichaCompleta: {
      type: Boolean,
      required: true
    }
  },

  components: {
    ContatosPcoCircuitoComponent
  },

  methods: {
    formataDataBr,

  }
}
</script>
